import { EntityId } from '@shared/core/types/index';
import { WaysOfConnectingEnum } from '@crm/admin/tools/product-config/types';
import { EServiceTypeKey } from '@skyeng/libs/shared/stk';

export interface ProductConfiguration {
  serviceTypeKey: EServiceTypeKey;
  isInternational: boolean;
  title: string;
  shortTitle: string;
  configuration: ProductStkConfiguration | null;
  substituteGroup: ProductConfigurationSubstituteGroup | null;
  isDeleted?: boolean;
}

export interface ProductStkConfiguration {
  typeOfTeacher: ProductStkConfigurationTypeOfTeacher | null;
  ageGradation: ProductStkConfigurationAgeGradation | null;
  maturity: ProductStkConfigurationMaturity | null;
  waysOfConnectingProductInstance: WaysOfConnectingEnum[] | [];
  isHiddenChildAvailable: boolean;
  isVisibleInUserInterface: boolean | true;
  lessonFormat: LessonFormats | null;
}

export interface ProductConfigurationSubstituteGroup {
  id: EntityId;
  title: string;
}

export enum ProductStkConfigurationTypeOfTeacher {
  native = 'native',
  not_native = 'not_native',
}

export enum ProductStkConfigurationAgeGradation {
  klp = 'klp',
  junior = 'junior',
}

export enum ProductStkConfigurationMaturity {
  adult = 'adult',
  kids = 'kids',
}

export enum LessonFormats {
  f2f = 'f2f',
  f2g = 'f2g',
  pl = 'pl',
  largeclasses = 'large-classes',
  selfstudy = 'self-study',
  recording = 'recording',
  course = 'course',
  showcase = 'showcase',
  consultation = 'consultation',
  discussion = 'discussion',
  unknown = 'unknown',
}

export enum IntroLessonFormats {
  f2f = 'face_to_face',
  f2g = 'f2g',
  autoPilot = 'auto_pilot',
}
